import httpService from "../../services/httpservice";
import { sha256 } from "js-sha256";
import config from "../../config";
import { createSlice } from "@reduxjs/toolkit";
import httpservice from "../../services/httpservice";
import { NotificationManager } from "../../components/common/react-notifications";
import { createBrowserHistory } from "history";

import storage from "../../helpers/storage";
import logger from "helpers/logger";

export const slice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    error: undefined,
    user: storage.getUser(),

    token: storage.getAuthToken(),
  },
  reducers: {
    /* LOGIN USER */
    loginUserStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    loginUserSuccess: (state, action) => {
      state.loading = false;
      state.user = { ...action.payload.user };
      state.token = action.payload.token;

      // STORE VALUES
      storage.saveUser(action.payload.user);
      storage.saveAuthToken(action.payload.token);
    },
    loginUserError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    /* FORGOT PASSWORD */
    forgotPasswordStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    forgotPasswordSuccess: (state) => {
      state.loading = false;
    },
    forgotPasswordError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    /* RESET PASSWORD */
    resetPasswordStart: (state, action) => {
      state.loading = true;
      state.error = undefined;
    },
    resetPasswordSuccess: (state) => {
      state.loading = false;
      state.user = undefined;
      state.token = null;

      // RESET VALUES
      storage.getUser();
      storage.resetAuthToken();
    },
    resetPasswordError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    /* REGISTER USER */
    registerUserStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    registerUserSuccess: (state) => {
      state.loading = false;
      state.error = undefined;
    },
    registerUserError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    /* LOGOUT USER */
    logoutUserStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    logoutUserSuccess: (state) => {
      state.user = undefined;
      state.loading = false;
      state.token = null;

      // RESET VALUES
      storage.getUser();
      storage.resetAuthToken();
    },
    logoutUserError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    getTokenValidity: (state, action) => {},

    updateUserInfo: (state, action) => {
      const user = action.payload;
      state.user = { ...state.user, ...user };

      // STORE VALUES
      storage.saveUser(user);
    },
  },
});

// Action creators are generated for each case reducer function
const {
  loginUserStart,
  loginUserSuccess,
  loginUserError,

  registerUserStart,
  registerUserSuccess,
  registerUserError,

  logoutUserStart,
  logoutUserSuccess,
  logoutUserError,

  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordError,

  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordError,
} = slice.actions;

export const { updateUserInfo } = slice.actions;

// ASYNC ACTIONS
export const loginUser = (values, history) => async (dispatch) => {
  dispatch(loginUserStart());

  const { email, password } = values;

  const url = config.url.authenticate + config.endpoint.authenticate;
  const body = {
    "X-Auth-Username": email,
    "X-Auth-Password": sha256(password),
  };

  httpService
    .post(url, body, {
      headers: {
        IS_FP: "False",
        "X-Device-Type": "PORTAL",
        "X-Channel": "WEB",
      },
    })
    .then((response) => {
      const { responseCode, responseDescription } = response.data;
      if (responseCode === "00") {
        const { token, details } = response.data.data;
        dispatch(loginUserSuccess({ user: details, token }));
        httpservice.configAuthHeader(token);
        history.replace("/");
      } else {
        NotificationManager.error(responseDescription, "Error");
        dispatch(
          loginUserError({
            message: `ERROR [${responseCode}] - ${responseDescription}`,
          })
        );
      }
    })
    .catch((error) => {
      NotificationManager.error(error.message, "Error");
      dispatch(loginUserError({ message: `ERROR - ${error.message}` }));
    });
};

export const forgotPassword =
  (forgotUserMail, token, history) => async (dispatch) => {
    dispatch(forgotPasswordStart());

    const url =
      config.url.authenticate +
      config.method.register +
      "/" +
      config.endpoint.forgotPassword +
      "?channel=WEB";
    const body = {
      emailAddress: forgotUserMail,
      captchaResponse: token,
    };

    httpService
      .post(url, body)
      .then((response) => {
        const { responseCode, responseDescription } = response.data;

        if (responseCode === "00") {
          dispatch(forgotPasswordSuccess());
          NotificationManager.success(
            "Password Reset Successfully.",
            "Success"
          );

          setTimeout(() => history.replace("/user/login"), 1000 * 3);
        } else {
          NotificationManager.error(responseDescription, "Error");
          dispatch(
            forgotPasswordError({
              message: `ERROR [${responseCode}] - ${responseDescription}`,
            })
          );
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "Error");
        dispatch(forgotPasswordError({ message: `ERROR - ${error.message}` }));
      });
  };

export const resetPassword = (payload) => async (dispatch) => {
  dispatch(resetPasswordStart());

  const { token, newPassword, captchaResponse, history } = payload;

  const url =
    config.url.authenticate +
    config.method.register +
    "/" +
    config.endpoint.changePassword +
    "?channel=WEB";

  const body = {
    token,
    newPassword,
    confirmPassword: newPassword,
    captchaResponse,
  };

  httpservice
    .post(url, body)
    .then((response) => {
      const { responseCode, responseDescription } = response.data;

      if (responseCode === "00") {
        dispatch(resetPasswordSuccess());
        NotificationManager.success("Password Reset Successfully.", "Success");
        history.replace("/user/login");
      } else {
        NotificationManager.error(responseDescription, "Error");
        dispatch(
          resetPasswordError({
            message: `ERROR [${responseCode}] - ${responseDescription}`,
          })
        );
      }
    })
    .catch((error) => {
      NotificationManager.error(error.message, "Error");
      dispatch(resetPasswordError({ message: `ERROR - ${error.message}` }));
    });
};

export const registerUser =
  (user, captchaResponse, history) => async (dispatch) => {
    dispatch(registerUserStart());

    const { email, password, fullName, mobileNumber, website } = user;

    const url =
      config.url.authenticate +
      config.method.register +
      "/" +
      config.endpoint.signup;
    const body = {
      appVersion: "",
      channel: "WEB",
      deviceId: "",
      deviceToken: "",
      deviceType: "ANDROID",
      email: email,
      fullName: fullName,
      lattitude: "",
      longitude: "",
      mobileNumber: mobileNumber,
      password: password,
      websiteURL: website,
      captchaResponse: captchaResponse,
    };

    httpService
      .post(url, body)
      .then((response) => {
        const { responseCode, responseDescription } = response.data;
        if (responseCode === "00") {
          dispatch(registerUserSuccess());
          NotificationManager.success(responseDescription, "Success");
          history.replace("/user/login"); // MOVE THE USER TO LOGIN PAGE
        } else {
          NotificationManager.error(responseDescription, "Error");
          dispatch(
            registerUserError({
              message: `ERROR [${responseCode}] - ${responseDescription}`,
            })
          );
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "Error");
        dispatch(registerUserError({ message: `ERROR - ${error.message}` }));
      });
  };

export const logoutUser = () => async (dispatch) => {
  // logger.log("Logging out");
  dispatch(logoutUserStart());

  const url = config.url.account + config.endpoint.logout + "?channel=WEB";
  const body = {};
  httpService
    .post(url, body)
    .then((response) => {
      const { responseCode, responseDescription } = response.data;

      if (responseCode) {
        storage.resetAll();
        dispatch(logoutUserSuccess());
        createBrowserHistory().push("/user/login");
      } else {
        dispatch(
          logoutUserError({
            message: `ERROR [${responseCode}] - ${responseDescription}`,
          })
        );
      }
    })
    .catch((error) => {
      dispatch(logoutUserError({ message: `ERROR - ${error.message}` }));
    });
};

export const getTokenValidity = (payload) => async (dispatch) => {
  const { history, token, setResponseData, setErrorData } = payload;

  const url =
    config.url.authenticate +
    config.method.register +
    "/" +
    config.endpoint.forgetPassword +
    "/" +
    token;
  const body = {};

  httpService
    .post(url, body)
    .then((response) => {
      const { responseCode, responseDescription } = response.data;
      if (responseCode === "00") {
        setResponseData(response);
      } else {
        setErrorData({
          message: `ERROR [${responseCode}] - ${responseDescription}`,
        });
        history.replace("/user/login");
      }
    })
    .catch((error) => {
      setErrorData({ message: `ERROR - ${error.message}` });
    });
};

export default slice.reducer;
